import React from "react";
import Marquee from "react-fast-marquee";

// Real client roster
const clients = [
  "SIGNATURE PSC",
  "VAIDEHI ATELIER",
  "BUDDING MALLUS",
  "BUDDING STORIES",
  "AYUSH SPANDANAM",
  "HARSHAKUMAR SREENIVASAN",
  "DR. SHAJI PRABHAKARAN",
  "VISIT VARKALA",
  "GRANTHA CARE PVT LTD",
  "PAGE SHIELD",
  "BUDDING LEADERS",
  "VIHAAN COUTURE",
];

const Clients = () => {
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="border-y border-black/10 bg-[#f6f6f4] py-14"
    >
      <div className="section-gutter mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="overline text-black/60">Chapter 05 — The Roster</div>
          <h3 className="font-serif-display text-3xl md:text-4xl mt-3">
            Trusted by leadership across <em>India.</em>
          </h3>
        </div>
        <div className="text-[0.7rem] uppercase tracking-[0.22em] text-black/50">
          Selected clients · 2021 – 2025
        </div>
      </div>
      <Marquee speed={30} gradient={false} pauseOnHover>
        {clients.concat(clients).map((c, i) => (
          <span
            key={i}
            className="mx-10 font-sans-display tracking-[0.18em] text-sm md:text-base text-black/70 font-semibold uppercase whitespace-nowrap"
          >
            {c} <span className="mx-6 text-black/30">/</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default Clients;
